/**
 * Aeries paints a first-name alias in parentheses next to STU.FN
 * ("Hex (Benny)"). The alias lives in STU.FNA / FirstNameAlias, not
 * inside the first-name field. Query exports and the API return them
 * separately.
 *
 * Blank aliases, and aliases that repeat the first name, are left off.
 * A first name that already contains the parenthetical is not wrapped again.
 */

export const FIRST_NAME_ALIAS_HEADERS = [
  'first name alias',
  'stu.fna',
  'alias first name',
  'student alias first name',
  'firstname alias'
]

export function firstNameWithAlias(firstName, alias) {
  const first = String(firstName ?? '').trim()
  const nick = String(alias ?? '').trim()
  if (!nick) return first
  if (first.toLowerCase() === nick.toLowerCase()) return first
  if (first.toLowerCase().includes(`(${nick.toLowerCase()})`)) return first
  if (!first) return nick
  return `${first} (${nick})`
}

/**
 * Split a display name back into first and last.
 * "Hex (Benny) Smith" → first "Hex (Benny)", last "Smith".
 * A parenthetical group stays with the first name, including spaces inside it.
 * Without parentheses this is the same as first-token / the rest.
 */
export function splitAeriesDisplayName(fullName) {
  const name = String(fullName ?? '')
    .trim()
    .replace(/\s+/g, ' ')
  if (!name) return { firstName: '', lastName: '' }
  const match = name.match(/^(\S+(?:\s+\([^)]*\))*)\s*(.*)$/)
  if (!match) return { firstName: name, lastName: '' }
  return { firstName: match[1], lastName: match[2] }
}
